export const BULK_UPLOAD_STATUS_MAP = {
  COMPLETED: "success",
  PARTIALLY_COMPLETED: "warning",
  PARTIALLY_PROCESSED: "warning",
  PENDING_APPROVAL: "primary",
  PENDING_VALIDATION_ERRORS: "error",
  VALIDATION_FAILED: "error",
  FILE_UPLOAD_FAILED: "error",
  PROCESSING: "primary",
  FAILED: "error",
};

export const BULK_UPLOAD_STATUS_OPTIONS = [
  { value: "all", label: "All Statuses" },
  { value: "PENDING_APPROVAL", label: "Pending Approval" },
  { value: "PENDING_VALIDATION_ERRORS", label: "Pending Validation Errors" },
  { value: "FILE_UPLOAD_FAILED", label: "File Upload Failed" },
  { value: "PROCESSING", label: "Processing" },
  { value: "COMPLETED", label: "Completed" },
  { value: "PARTIALLY_COMPLETED", label: "Partially Completed" },
  { value: "PARTIALLY_PROCESSED", label: "Partially Processed" },
  { value: "FAILED", label: "Failed" },
];
export const BULK_UPLOAD_STATUS_LABEL = Object.fromEntries(
  BULK_UPLOAD_STATUS_OPTIONS.filter((o) => o.value !== "all").map((o) => [
    o.value,
    o.label,
  ]),
);

export const BULK_UPLOAD_STATUS_VALUE_BY_LABEL = Object.fromEntries(
  BULK_UPLOAD_STATUS_OPTIONS.filter((o) => o.value !== "all").map((o) => [
    o.label,
    o.value,
  ]),
);

export const DEFAULT_BULK_UPLOADS_FILTERS = {
  searchQuery: "",
  dateRange: { startDate: null, endDate: null },
  status: "all",
};

export const DEFAULT_BULK_UPLOADS_PAGINATION = { pageIndex: 0, pageSize: 10 };
